import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, CardImg } from 'reactstrap';
import { URL } from "../../config"


const IterinaryModal = ({product}) => {
  // console.log(product)

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <div>
      <Button color="outline-primary" onClick={toggle} className="btn-block">Itinerary</Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Itinerary</ModalHeader>
        <ModalBody key={product._id}>
              <CardImg src={`${URL}/${product.image}`} alt="tour image" height="300" className="mb-3" />
              <h5 className="text-center">{product.name}</h5>
              <p className="line-break text-justify">{product.iterinary}</p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center">
          <Button className="btn-danger" onClick={toggle}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default IterinaryModal;